/*
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3945 Freedom Circle, Suite 730 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'
import PropTypes from 'prop-types'
import { useDashboardWidgetSetting } from '../../../hooks/useDashboardState'
import { useDashboardWidgetData } from '../../../hooks/useWidgetState'
import ChartFactory from './ChartFactory'

const CustomVisualization = ({ widgetId }) => {
  const widgetSetting = useDashboardWidgetSetting(widgetId)
  const widgetData = useDashboardWidgetData(widgetId)
  const data = widgetData?.data?.data

  return (
    <ChartFactory type={widgetSetting.chart.type} data={data} config={widgetSetting.chart.config} />
  )
}

CustomVisualization.propTypes = {
  widgetId: PropTypes.number.isRequired
}

export default CustomVisualization
